import { __awaiter, __generator } from "tslib";
import axios from 'axios';
import * as Gateways from './Gateways';
export var ICcTokenizerClient = Symbol();
var CcTokenizerClient = (function () {
    function CcTokenizerClient(config) {
        this._httpClient = (config && config.httpClient) || axios.create();
        this._authTokenEndpoint =
            (config && config.authTokenEndpoint) || '/v1/auth-token';
        this._bPointBaseUrl =
            (config && config.bPointBaseUrl) ||
                'https://www.bpoint.com.au/webapi/v3';
        this._eWayBaseUrl =
            (config && config.eWayBaseUrl) || 'https://api.ewaypayments.com';
    }
    CcTokenizerClient.prototype.TokenizeCreditCard = function (gatewayType, customerRef, creditCard, isOssUser) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, gw, auth, tokenResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.getAuthenticatedGateway(gatewayType, 'creditcard', customerRef)];
                    case 1:
                        _a = _b.sent(), gw = _a.gw, auth = _a.auth;
                        return [4, gw.TokenizeCreditCard(auth, creditCard, customerRef)];
                    case 2:
                        tokenResponse = _b.sent();
                        return [4, this.submitResultTokenToTokenReceipt(tokenResponse, customerRef, isOssUser)];
                    case 3:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    CcTokenizerClient.prototype.TokenizeBankAccount = function (gatewayType, customerRef, bankAccount, isOssUser) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, gw, auth, tokenResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.getAuthenticatedGateway(gatewayType, 'directdebit', customerRef)];
                    case 1:
                        _a = _b.sent(), gw = _a.gw, auth = _a.auth;
                        return [4, gw.TokenizeBankAccount(auth, bankAccount, customerRef)];
                    case 2:
                        tokenResponse = _b.sent();
                        return [4, this.submitResultTokenToTokenReceipt(tokenResponse, customerRef, isOssUser)];
                    case 3:
                        _b.sent();
                        return [2];
                }
            });
        });
    };
    CcTokenizerClient.prototype.TokenizeOw30DayAccount = function (customerRef, popup, isOssUser) {
        return __awaiter(this, void 0, void 0, function () {
            var gw, tokenResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        gw = new Gateways.Ow30DayAccount(this._authTokenEndpoint);
                        return [4, gw.TokenizeOw30DayAccount(popup)];
                    case 1:
                        tokenResponse = _a.sent();
                        return [4, this.submitResultTokenToTokenReceipt(tokenResponse, customerRef, isOssUser)];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    CcTokenizerClient.prototype.getAuthenticatedGateway = function (gatewayType, paymentType, customerRef) {
        return __awaiter(this, void 0, void 0, function () {
            var query, authTokenRequest, authTokenResponse, gateway;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = { customerRef: customerRef };
                        authTokenRequest = this._httpClient.get(this._authTokenEndpoint + "/" + gatewayType + "/" + paymentType, { params: query });
                        return [4, authTokenRequest];
                    case 1:
                        authTokenResponse = (_a.sent())
                            .data;
                        switch (gatewayType) {
                            case 'bpoint':
                                gateway = new Gateways.Bpoint(axios.create({ baseURL: this._bPointBaseUrl }));
                                break;
                            case 'eway':
                                gateway = new Gateways.Eway(axios.create({ baseURL: this._eWayBaseUrl }));
                                break;
                            default:
                                throw new Error('Invalid Gateway Type!');
                        }
                        return [2, { gw: gateway, auth: authTokenResponse }];
                }
            });
        });
    };
    CcTokenizerClient.prototype.submitResultTokenToTokenReceipt = function (tokenResponse, customerRef, isOssUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._httpClient.post(tokenResponse.redirectUrl.split('?')[0], {
                            resultToken: tokenResponse.resultToken,
                            customerRef: customerRef,
                            isOssUser: isOssUser,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return CcTokenizerClient;
}());
export { CcTokenizerClient };
//# sourceMappingURL=CcTokenizerClient.js.map